/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cx from 'classnames';
import { Actionable, Icon, Text, View } from '@az/starc-ui';
import { ChevronRight, Close } from '@az/starc-ui-icons';
import styles from './styles.module.scss';
import { useModalOPPromptContext } from '@/components/ModalOPPromptContext';
import { usePostAcknowldegeMutation } from '@/features/rewards/api/postRewardsAcknowledge';
import { localStorage } from '@/utils/localStorage';
import { useLabels } from '@/hooks/useLabels';
import { useLocale } from '@/hooks/useLocale';

const labelMap = {
  closePromotion: 'label_close_promotion',
};

export const SideTab = () => {
  const labels = useLabels(labelMap);
  const { offer, promoState, emailPromptAlertType, handleTogglePromo, updatePromoState } =
    useModalOPPromptContext();
  const { mutate: acknowledgementMutation } = usePostAcknowldegeMutation();
  const locale = useLocale();
  const isUS = locale === 'en-US';
  const showModal = isUS;

  const handlePostRequest = () => acknowledgementMutation({ alertType: 'OP' });

  const handleClosePromo = () => {
    localStorage.setItem('displayEmailOptInAlert', 'false');
    if (emailPromptAlertType) {
      handlePostRequest();
    }
    updatePromoState({
      isOpen: false,
      isClosed: true,
    });
  };

  const greenChevron = promoState.isConfirmed && showModal;
  const iconColor = greenChevron ? 'success' : 'accent';

  return (
    <View className={styles.emailTabMinimized}>
      <View className={styles.emailTabMinimizedContent}>
        <Actionable onClick={handleClosePromo} attributes={{ 'data-testid': 'close-promo' }}>
          <Icon svg={Close} size={5} />
          <p className="sr-only">{labels.closePromotion}</p>
        </Actionable>
        <Actionable
          onClick={handleTogglePromo}
          className={styles.promoToggle}
          attributes={{
            'aria-expanded': promoState.isOpen,
            'data-testid': 'promo-toggle',
            'data-color': iconColor,
          }}
        >
          <Text variant="large-body" color="600" className={styles.promoText}>
            {offer?.discount}
          </Text>
          <Icon
            svg={ChevronRight}
            className={cx(styles.chevronIcon, {
              [styles.rotateToggle]: promoState.isOpen && !showModal,
            })}
            size={5}
            color={iconColor}
          />
        </Actionable>
      </View>
    </View>
  );
};
